import * as React from 'react';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import {useEffect} from "react";
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import {useMediaQuery, useTheme} from "@mui/material";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';


const UHDPlayer = ({player}) => {

    const [checked, setChecked] = React.useState(false);

    // We keep track of the selected bitrate in state, though the RadioGroup uses player?.getVideoBitrate()
    const [videoBitrate, setVideoBitrate] = React.useState(0);

    const [videoBitrates, setVideoBitrates] = React.useState([]);

    const handleChange = (event) => {
        // The value from the radio button is a string, convert to number
        const newBitrate = Number(event.target.value);
        player?.setVideoBitrate(newBitrate);
        setVideoBitrate(newBitrate);
        setChecked(false);
        if(newBitrate === Infinity || newBitrate === player?.getMaxVideoBitrate()){
            setChecked(true);
        }
    }

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    useEffect(() => {
        const loadBitrates = () => {

            // --- FIX APPLIED HERE ---
            // 1. Corrected method: getAvailableVideoBitrates() is used to fetch the list of qualities.
            // 2. Added Array.isArray() check for robustness.
            const availableVideoBitrates = player?.getAvailableVideoBitrates?.();
            if (Array.isArray(availableVideoBitrates) && availableVideoBitrates.length > 0) {
                const videoBitrates = [...availableVideoBitrates, 0];
                setVideoBitrates(videoBitrates);
                console.log("Available Bitrates:", videoBitrates);
            } else {
                // If the player method doesn't exist or doesn't return an array,
                // we set the array to empty to avoid the .map() error.
                console.error("Player API issue: player.getAvailableVideoBitrates() is missing or not returning an array.");
                setVideoBitrates([]);
            }
            // --- END FIX ---

            const minBitrate = player?.getMinVideoBitrate();

            // Logic to determine initial 'UHD' switch state
            if (minBitrate === Infinity) {
                setChecked(true);
            }
            else {
                const currentBitrate = player?.getVideoBitrate();
                if (currentBitrate === Infinity) {
                    setChecked(true);
                }
            }
        }
        loadBitrates();

        // Note: For a real player, you might also need event listeners here
        // to update the bitrates when the source changes.
    }, [player, setVideoBitrates, setChecked, videoBitrate]);

    return (
        <>
            <FormControl >
                <FormGroup aria-label="position" row>
                    <FormControlLabel style={{marginLeft:10,}}
                                      control={<Switch checked={ player?.getVideoBitrate() === Infinity || checked }
                                                       color="primary" />}
                                      label={
                                          <label style={{fontSize : isDesktop? 25 : 10, color: "white",  fontWeight:"lighter"}} className={"text-field-label"}>UHD</label>
                                      }
                                      onChange={(e) => {
                                          setChecked(e.target.checked);
                                          if (e.target.checked) {
                                              // Set minimum bitrate to Infinity to force highest quality
                                              player.setMinVideoBitrate(Infinity);
                                          }
                                          else {
                                              // Set minimum bitrate to 0 to allow all qualities
                                              player.setMinVideoBitrate(0);
                                          }
                                      }}
                                      labelPlacement="end"
                    />
                </FormGroup>
            </FormControl>

            <div className={"card-videos-bitrate"} style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <VideoSettingsIcon sx={{ color: 'white', fontSize: isDesktop? 40 : 20}} />
                <Box sx={{ minWidth: isDesktop ? 150 : 100 }}>
                    <Select
                        labelId="video-quality-select-label"
                        id="video-quality-select"
                        value={player?.getVideoBitrate() || videoBitrate}
                        // Apply dark background to the closed select box
                        sx={{
                            background: '#333333',
                            fontFamily: 'Orbitron',
                            color: 'white',
                            '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.4)' }, // Border color
                            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                            '.MuiSvgIcon-root': { color: 'white' } // Arrow icon color
                        }}
                        onChange={handleChange}
                        // --- FIX: Style the dropdown menu (Paper) container ---
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    bgcolor: '#1e1e1e', // Dark background for the dropdown list
                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                },
                            },
                        }}
                        // --------------------------------------------------------
                    >
                        {videoBitrates.map((bitrate) => (
                            // Check if bitrate is a positive number
                             bitrate !== Infinity ? (
                                <MenuItem

                                    key={bitrate}
                                    value={bitrate.toString()}
                                    // Style for menu item text and background
                                    sx={{
                                        fontFamily: 'Orbitron',
                                        color: 'white',
                                        fontSize: isDesktop ? 18 : 12,
                                        // Ensure hover state is visible on dark background
                                        '&:hover': {
                                            backgroundColor: '#333333',
                                        },
                                        // Ensure selected item stays white
                                        '&.Mui-selected': {
                                            backgroundColor: '#444444',
                                            color: 'white',
                                            '&:hover': {
                                                backgroundColor: '#333333',
                                            }
                                        }
                                    }}
                                >
                                    {/* Simplify label content */}
                                    {bitrate !== 0 ? (bitrate / 1000) : "Auto" } p
                                </MenuItem>
                            ) : null
                        ))}

                    </Select>
                </Box>

            </div>

        </>
    );
}

export default UHDPlayer;